<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            Manage Shutdown Days and Allowed Carry Forward
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row align-items-center">
      <div class="col-md-1">Company</div>
      <div class="col-md-4 p-0 fit-content">
        <select class="custom-select" v-model="company">
          <option
            v-for="(item, i) in companies"
            :key="i"
            :value="item.CompanyName"
          >
            {{ item.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Table List -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center action-column">Action</th>
                <th style="width: 10%">Year</th>
                <th style="width: 40%">Shutdown Days</th>
                <th>Allowed Carry Forward</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <template v-if="formData.Year !== item.Year">
                  <td class="text-center action-column">
                    <button class="btn mt-2" title="Edit" @click="edit(item)">
                      <i class="fa fa-edit"></i>
                    </button>
                  </td>
                  <td>{{ item.Year }}</td>
                  <td>{{ item.ShutdownDays }}</td>
                  <td>{{ item.AllowedCarryForward }}</td>
                </template>
                <template v-else>
                  <td class="text-center action-column table-info">
                    <button
                      type="button"
                      class="btn"
                      title="Save"
                      @click="save"
                    >
                      <i class="fa fa-save"></i>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      title="Cancel"
                      @click="cancel"
                    >
                      <i class="fa fa-window-close-o"></i>
                    </button>
                  </td>
                  <td class="table-info">{{ item.Year }}</td>
                  <td class="table-info">
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.ShutdownDays"
                      min="0"
                    />
                  </td>
                  <td class="table-info">
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.AllowedCarryForward"
                      min="0"
                    />
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      defaultCompany: config.DEFAULT_COMPANY,
      company: "",
      companies: [],
      records: [],
      formData: {
        Id: null,
        Year: null,
        ShutdownDays: null,
        AllowedCarryForward: null,
      },
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
  },
  watch: {
    company(val) {
      this.resetForm();
      this.getShutdownCarryForward(val);
    },
  },
  methods: {
    //filter
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            if (
              this.companies.find(
                (c) => c.CompanyName == this.defaultCompany
              ) == null
            ) {
              this.companies.push({ CompanyName: this.defaultCompany });
            }
            this.company = this.defaultCompany;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //action
    resetForm() {
      this.formData = {
        Id: null,
        Year: null,
        ShutdownDays: null,
        AllowedCarryForward: null,
      };
    },
    edit(payload) {
      this.resetForm();
      this.formData.Id = payload.Id;
      this.formData.Year = payload.Year;
      this.formData.ShutdownDays = payload.ShutdownDays;
      this.formData.AllowedCarryForward = payload.AllowedCarryForward;
    },
    cancel() {
      this.resetForm();
      this.getShutdownCarryForward(this.company);
    },
    //main
    getShutdownCarryForward(company) {
      let param = {
        Token: this.token,
        Company: company,
      };
      this.$store.state.isLoading = true;
      API.getShutdownCarryForward(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let date = new Date();
            let minYear = date.getFullYear() - 1;
            let maxYear = date.getFullYear() + 1;
            this.records = [];
            for (let year = minYear; year <= maxYear; year++) {
              let rec = response.data.record.find((c) => c.Year == year);
              if (rec == null) {
                this.records.push({
                  Id: null,
                  Year: year,
                  ShutdownDays: null,
                  AllowedCarryForward: null,
                });
              } else {
                this.records.push({
                  Id: rec.Id,
                  Year: rec.Year,
                  ShutdownDays: rec.ShutdownDays,
                  AllowedCarryForward: rec.AllowedCarryForward,
                });
              }
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.formData.Id,
        Company: this.company,
        Year: this.formData.Year,
        ShutdownDays: this.formData.ShutdownDays,
        AllowedCarryForward: this.formData.AllowedCarryForward,
      };
      this.$store.state.isLoading = true;
      API.saveShutdownCarryForward(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.cancel();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getCompanies();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
table {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/LeaveUtilizationReport/ManageShutdownCarryForward.vue